export default function Archived() {
  return (
    <div>
      <h4 className="list__title--order-data">Archived Order</h4>
    </div>
  )
}
